import { useEffect, useRef, useState } from 'react'
import {jwtDecode} from 'jwt-decode'
import axios from 'axios'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import student_store from '../store/student_store'
import '../assets/css/app.css'
import '../assets/css/pages/auth.css'
import styles from '../css/styles.module.css'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import supervisor_store from '../store/supervisor_store'
import admin_store from '../store/admin_store'
import { toast } from 'react-toastify'
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google'
import coursestatus_store from '../store/coursestatus_store'

// import '../assets/js/bootstrap.js'
// import '../assets/js/pages/dashboard.js'
function Login_Page() {
  const student = student_store((state) => state.student)
  const loginStudent = student_store((state) => state.loginStudent)
  const loginSupervisor = supervisor_store((state) => state.loginSupervisor)
  const loginAdmin = admin_store((state) => state.loginAdmin)
  const navigate = useNavigate()
  const location = useLocation()
  const [user, setUser] = useState({})

  const from = location.state?.from?.pathname || '/'
  const [item, setItem] = useState('Student')

  const handleChange = (e) => {
    setItem(e.target.value)
  }
  const suffix = process.env.REACT_APP_SUFFIX_ROUTE

  return (
    <>
      <div id='auth'>
        <div className='row h-100'>
      
          <div className='col-lg-5 col-12'>
            <div id='auth-left'>
              <div className='auth-logo '>
                <a>
                  <img srcSet={require('../assets/images/logo/logo.png')} />
                </a>
              </div>
              <h1 className='auth-title'>Advising Portal</h1>
              <h3 className='login-info'>Select one</h3>
              {/* <p className="auth-subtitle mb-5">
                choose <span className='text-primary' >yourname@auis.edu.krd</span> to signin
              </p> */}
              <div className='row'>
                <Form.Group controlId='item'>
                  <Form.Check
                    value='Student'
                    type='radio'
                    aria-label='Student'
                    label='Student'
                    onChange={handleChange}
                    checked={item === 'Student'}
                  />
                  <Form.Check
                    value='Supervisor'
                    type='radio'
                    aria-label='Supervisor'
                    label='Advisor'
                    onChange={handleChange}
                    checked={item === 'Supervisor'}
                  />
                  <Form.Check
                    value='Admin'
                    type='radio'
                    aria-label='Admin'
                    label='Administrator'
                    onChange={handleChange}
                    checked={item === 'Admin'}
                  />
                </Form.Group>
              </div>
              <div className='text-center mt-5 text-lg fs-4'>
                {/* <div id='signInDiv' className=''></div> */}{' '}
                <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID} >
                  <GoogleLogin
                    onSuccess={async (credentialResponse) => {
                      let studentect = jwtDecode(credentialResponse.credential)
                      if (Object.keys(studentect).length != 0) {
                        try {
                          const payload = {
                            email: studentect?.email ?? '.',
                            image: studentect?.picture ?? '.',
                            name: studentect?.name ?? '.',
                            status: 'a',
                          }
                          let response
                          if (item == 'Student') {
                            response = await loginStudent(payload)
                            navigate(`${suffix}/policies`)
                          } else if (item == 'Supervisor') {
                            response = await loginSupervisor(payload)
                            navigate(`${suffix}/policies`)
                          } else if (item == 'Admin') {
                            response = await loginAdmin(payload)
                            navigate(`${suffix}/`)
                          }
                          if (Object.keys(response).length == 0) return
                        } catch (error) {
                          const errmsg = error.response?.data?.message
                          if (!errmsg) return

                          // show error reason as an error toast
                          if (Array.isArray(errmsg)) {
                            errmsg.forEach((element, index) => {
                              setTimeout(function () {
                                toast.error(element)
                              }, 200 * index)
                            })
                          } else {
                            toast.error(errmsg)
                          }
                        }
                      }
                    }}
                    onError={() => { }}
                  />
                </GoogleOAuthProvider>
              </div>
            </div>
          </div>
          <div className='col-lg-7 d-none d-lg-block'>
            <div id='auth-right'>
              {/* {<img className='' srcSet='https://auis.edu.krd/sites/default/files/Campus%202019.jpg' />} */}
            </div>
          </div>
          
        </div>
      </div>
    </>
  )
}

export default Login_Page
